<template>
  <h1>Buy me a coffee here</h1>
</template>
<script>
export default {
  name: "Buy",
};
</script>